import React from "react";
import { Snackbar, Typography } from "@mui/joy";

interface ToastNotificationProps {
  open: boolean;
  message: string;
  color: "success" | "danger";
  onClose: () => void;
}

export const ToastNotification: React.FC<ToastNotificationProps> = ({
  open,
  message,
  color,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      color={color}
      variant="solid"
      sx={{
        fontWeight: "md",
        px: 2,
        py: 1,
      }}
    >
      <Typography level="body-sm" fontWeight="lg">
        {message}
      </Typography>
    </Snackbar>
  );
};